/**
 * Builds a deterministic GUID-shaped window geo scope from browser tabId + workspace rk.
 * The BE WindowPosition endpoint rejects a composite `${tabId}:${wsRk}` (400), a GUID passes.
 * Same input always gives the same id (4x FNV-1a 32 bit with different seeds).
 */
export default class GeoScopeIdBuilder {
    /**
     * @param {string} tabId
     * @param {string} wsRk
     * @returns {string} 8-4-4-4-12 hex id
     */
    static build(tabId, wsRk) {
        const src = `${tabId}:${wsRk}`;
        const hex = [0x811c9dc5, 0x01000193, 0x050c5d1f, 0x2166136b].map((seed) => GeoScopeIdBuilder._fnv1a(src, seed)).join('');
        return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20, 32)}`;
    }

    static _fnv1a(str, seed) {
        let h = seed >>> 0;
        for (let i = 0; i < str.length; i++) h = Math.imul(h ^ str.charCodeAt(i), 0x01000193) >>> 0;
        return h.toString(16).padStart(8, '0');
    }
}
